import React, { Component } from "react";

import "../../../../styles/components/account/manageAccount/guestUser/TopBarGuestUser.scss";
import back from "../../../../styles/images/arrow_black.svg";

class TopBarGuestUser extends Component {
  state = {};
  render() {
    return (
        <div id="topbar-guest-user">
            <div>
                <button
                    type="button"
                    className="clear back"
                    onClick={() => this.props.setContent("profile")}
                >
                    <img src={back} alt="back" />
                </button>
            </div>
        </div>
    );
  }
}

export default TopBarGuestUser;
